import { Pipe, PipeTransform } from '@angular/core';

import * as momentNs from 'moment-timezone';
const moment = momentNs;

const ZONE = 'Europe/London';
/**
 * Converts time string to how long ago
 *
 * __Usage :__
 *   time | ngxAgo: endTime
 *
 * __Example :__
 *   {{ '2017-01-01T15:00:00+00:00' | ngxAgo: '2017-01-02T15:00:00+00:00' }}
 *   formats to: 1 day
 *   {{ '2018-01-01T15:00:00+00:00' | ngxAgo }}
 *   formats to: 30 minutes
 *
 * Module {@link TransformAgoModule}
 */
@Pipe({
    name: 'ngxAgo'
})

export class TransformAgoPipe implements PipeTransform {
    transform(date: string, end?: string): string {
        const endTime = (end) ? moment.tz(end, ZONE) : moment.tz(ZONE);
        const start = moment.tz(date, ZONE);
        const diffs = moment.duration(endTime.diff(start));

        return diffs.humanize();
    }
}
